export default __webpack_public_path__ + "static/media/edited-29.cfebcd4f.jpg";